import React, { useCallback, useContext } from "react";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import { CommonTitleBar, CommonScatterChart } from "../../common";
import styled from "styled-components";
import { WebMapContext } from "../../../../pages/sections/web-map/WebMapGoogleMap";

const style = {
  position: "absolute",
  top: "55%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: '85vh',
  bgcolor: "background.paper",
  height: '80vh'
};

const TopLeft = styled.div`
  align-self: flex-start;
  position: absolute;
  padding-left: 60px;
  padding-bottom: 10px;
  font: normal normal normal 11px Open Sans;
`;

const TopRight = styled.div`
  align-self: flex-end;
  position: absolute;
  right: 20px;
  padding-bottom: 10px;
  font: normal normal normal 11px Open Sans;
`;

const BottomLeft = styled.div`
  align-self: flex-start;
  position: absolute;
  padding-left: 60px;
  bottom: 10px;
  font: normal normal normal 11px Open Sans;
`;

const BottomRight = styled.div`
  align-self: flex-end;
  position: absolute;
  bottom: 10px;
  right: 20px;
  font: normal normal normal 11px Open Sans;
`;

const ScatterModal = ({ isOpen, setIsOpen, scatterData, yRefLine,ADM, quadCount = [] }) => {
  const { quadLabelsConfig } = useContext(WebMapContext);
  const getSidePanelWidth = useCallback(() => {
    const element = document.getElementsByClassName("web-map-side-panel");
    if (element && element.length) {
      const newWidth = element[0].offsetWidth;
      return `${newWidth + 24}px`;
    }
  }, []);


  const viewportHeight = window.innerHeight;

  // Convert vh to pixels
  const vhToPixels = (vh) => (vh / 100) * viewportHeight;

  const getAdmCount = (quad) => {
    const countObj = quadCount.find(y => y.quad === quad);
    return countObj?.admCount || " - ";
  }

  return (
    <Modal
   
      open={isOpen}
      onClose={setIsOpen}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style} >
        <CommonTitleBar title={`Market Share Vs Network Performance`}>
          <div
            onClick={() => {
              setIsOpen(false);
            }}
            style={{
              cursor: "pointer",
            }}
          >
            <CloseRoundedIcon color="action" />{" "}
          </div>
        </CommonTitleBar>
        <div>
        <TopLeft>{`${quadLabelsConfig["A"] || "High MS - Poor NP / Invest to Defend"} (${getAdmCount("A")})`}</TopLeft>
        <TopRight>{`${quadLabelsConfig["B"] || "High MS - Good NP / Invest to Maintain"}  (${getAdmCount("B")})`}</TopRight></div>
        <div style={{ height: window.innerWidth > 1900 ?"62vh":"80vh",paddingTop:'15px',marginLeft:'15px' }}>
          <CommonScatterChart
             width={vhToPixels(80)-20}
             height={vhToPixels(80)-100}
             margin={{ top: 20, right: 30, bottom: 20, left: 40 }}
             data={scatterData}
             r={2}
             ADM={ADM}
             yRefLine={yRefLine}
             isOpen={isOpen}
          />
        </div>
        <div><BottomLeft>{`${quadLabelsConfig["C"] || "Low MS - Poor NP / Selective Investment"} (${getAdmCount("C")})`}</BottomLeft>
        <BottomRight>{`${quadLabelsConfig["D"] || "Low MS - Good NP / Selective Investment"} (${getAdmCount("D")})`}</BottomRight></div>
      </Box>
    </Modal>
  );
};

export default ScatterModal;
